import { useEffect } from 'react';
import secureLocalStorage from 'react-secure-storage';

export default function PaCallbackPage() {
  useEffect(() => {
    const params  = new URLSearchParams(window.location.search);
    const token   = params.get('token');
    const userRaw = params.get('user');
    const errore  = params.get('errore');

    if (errore) {
      window.location.replace('/login?errore=' + encodeURIComponent(errore));
      return;
    }

    if (!token || !userRaw) {
      window.location.replace('/login');
      return;
    }

    let user;
    try {
      const padded = userRaw.padEnd(userRaw.length + (4 - userRaw.length % 4) % 4, '=');
      user = JSON.parse(atob(padded));
    } catch {
      window.location.replace('/login');
      return;
    }

    const backend = window.VEDA_API_URL || '';

    // 1. Ottieni CSRF cookie
    fetch(`${backend}/sanctum/csrf-cookie`, { credentials: 'include' })
      .then(() => {
        const csrfToken = decodeURIComponent(
          document.cookie.split('; ').find((c) => c.startsWith('XSRF-TOKEN='))?.split('=')[1] ?? ''
        );

        // 2. Avvia sessione cookie Veda
        return fetch(`${backend}/api/v1/pa/sessione`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-XSRF-TOKEN': csrfToken,
          },
        });
      })
      .then(async (res) => {
        // 409: sul browser è già attiva la sessione di un altro utente.
        // Non tocchiamo lo storage (appartiene all'altra sessione) e torniamo
        // al login con il messaggio del backend.
        if (res.status === 409) {
          const body = await res.json().catch(() => null);
          const msg  = body?.message ?? 'Su questo browser è già attiva la sessione di un altro utente. Effettuare prima il logout.';
          window.location.replace('/login?errore=' + encodeURIComponent(msg));
          return null;
        }
        if (!res.ok) throw new Error(`sessione ${res.status}`);
        return res.json();
      })
      .then((shape) => {
        if (shape === null) return;
        // Salva lo shape della sessione cookie (più completo) in storage
        secureLocalStorage.setItem('veda_user', JSON.stringify({ ...shape, _sanctum_token: token }));
        window.location.replace('/pa/ente');
      })
      .catch((err) => {
        // La sessione cookie non è riuscita — salviamo comunque il token
        // Bearer come fallback, Veda potrebbe accettarlo
        console.error('PaCallback sessione error:', err);
        secureLocalStorage.setItem('veda_user', JSON.stringify({ ...user, _sanctum_token: token }));
        window.location.replace('/pa/ente');
      });
  }, []);

  return null;
}
